import { Heading } from "@/components";
import useTemplates from "./useTemplates";
import { cardList } from "./consts";
import { Card, CardContent } from "@/components/ui";
import { cn } from "@/lib/utils";

const Templates = () => {
  const {communityDetail, onCardClick} = useTemplates();
    return (
    <div className="p-4 md:p-6">
        {/* Header & Search */}
        <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
          <div className="flex flex-row items-center justify-between">
            <Heading
              title={`Templates - ${(communityDetail as any)?.name}`}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-2 gap-[30px]">
        {cardList.map((card: any) => {
          return (
            <Card
              className={cn(
                "h-[300px] w-auto rounded-3xl shadow-xl relative overflow-hidden transition-all hover:scale-105 hover:shadow-2xl cursor-pointer p-0 text-white",
                card?.className
              )}
              style={{
                backgroundImage: `url(${card.bgImg})`,
                backgroundSize: card?.backgroundSize,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "cover",
              }}
              onClick={() => onCardClick(card?.link)}
            >
              <CardContent className="flex flex-col items-start justify-center h-full p-0 relative">
                {/* Left Content */}
                <div className="px-4 absolute bottom-5">
                  <h3 className="text-2xl font-semibold mb-1">{card.title}</h3>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default Templates;